import { render } from "./detailRecord.vue?vue&type=template&id=74e6c3d7&scoped=true"
import script from "./detailRecord.vue?vue&type=script&lang=js"
export * from "./detailRecord.vue?vue&type=script&lang=js"

import "./detailRecord.vue?vue&type=style&index=0&id=74e6c3d7&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e6c3d7"]])

export default __exports__